// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export type IssueAreaChoice = "BEDROOMS"|"KITCHEN"|"LIVING_ROOM"|"BATHROOMS"|"HOME"|"PUBLIC_AREAS";

export const IssueAreaChoices: IssueAreaChoice[] = [
  "BEDROOMS",
  "KITCHEN",
  "LIVING_ROOM",
  "BATHROOMS",
  "HOME",
  "PUBLIC_AREAS"
];

const IssueAreaChoiceSet: Set<String> = new Set(IssueAreaChoices);

export function isIssueAreaChoice(choice: string): choice is IssueAreaChoice {
  return IssueAreaChoiceSet.has(choice);
}

export type IssueAreaChoiceLabels = {
  [k in IssueAreaChoice]: string;
};

export function getIssueAreaChoiceLabels(): IssueAreaChoiceLabels {
  return {
    BEDROOMS: "Bedrooms",
    KITCHEN: "Kitchen",
    LIVING_ROOM: "Living room",
    BATHROOMS: "Bathrooms",
    HOME: "Home-wide",
    PUBLIC_AREAS: "Building-wide",
  };
}
